export default function(jobAdText, jobTemplate) {
  let mappedText = jobAdText;

  if (!mappedText) {
    return  mappedText;
  }

  if (jobTemplate === 'apprenticeship') {
    mappedText = generateApprenticeTemplate(mappedText);
  }

  mappedText = generateJobTemplate(mappedText);

  return mappedText;
}

function generateJobTemplate(jobAdText) {
  let bulletPoints = jobAdText.split('</ul>');
  bulletPoints = bulletPoints.map(bulletpoint => {
    let content = bulletpoint.split('\n').filter(string => {
      if( string !== '') {
        return string;
      }
    });
    if( content.length <= 0 ) {
      return;
    }
    if (typeof content[0]  == 'string' && !content[0].includes('<ul>') && !content[0].includes('<li>')) {
      content[0] = `<p class="mr-h3-med text-mr-primary mb-m tablet:mr-h2-med">${content[0]}</p>`;
    }
    bulletpoint = content.join('\n');
    return `<div>${bulletpoint}</div>`;
  });

  return bulletPoints.join('</ul>');
}
function generateApprenticeTemplate(jobAdText) {
  let bulletPoints = jobAdText.split('</ul>');

  bulletPoints = bulletPoints.map(bulletpoint => {
    let content = bulletpoint.split('\n').filter(string => {
      if( string !== '') {
        return string;
      }
    });

    let regex = /<\/?[a-z][\s\S]*>/gmi;
    content = content.map(string => {
      if( string.length <= 0 ) {
        return string;
      }
      if (string.match(regex) === null) {
        return `<p class="mb-m">${string}</p>`;
      }
      return string;
    });
    bulletpoint = content.join('\n');
    return `<div>${bulletpoint}</div>`;
  });

  return bulletPoints.join('</ul>');
}
